import { createContext } from 'react';

export const NewsletterContext = createContext<
  | {
      cancelComposingNewsletter: () => void;
      canComposeNewsletter: boolean;
      closeNewsletterDialog: () => void;
      isComposingNewsletter: boolean;
      isNewsletterDialogOpen: boolean;
      openNewsletterDialog: () => void;
      selectedChangelogItemIds: ChangelogItem['id'][];
      sendNewsletter: (_msg: string) => Promise<boolean>;
      startComposingNewsletter: () => void;
      toggleSelectedChangelogItemId: (_id: ChangelogItem['id']) => void;
    }
  | undefined
>(undefined);
